<template>
  <div class="content-wrapper">
    <div class="container" style="background: white">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1 style="text-align: center; font-weight: bold">
          {{ pagetitle }}
        </h1>
        <br />
        <img
          src="assets/images/logonew.jpeg"
          alt="find"
          class="adjust"
          style="display: block; margin: auto"
        />
        <br />
      </section>
      <section class="content">
        <slot></slot>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  props: ["pagetitle"],
};
</script>

<style lang="scss" scoped></style>
